var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoPaddingMissingImageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D5DD",
    d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.225 8.615-5.887-3.372a4.727 4.727 0 0 0-4.676 0L7.775 8.615a4.658 4.658 0 0 0-1.708 1.696 4.623 4.623 0 0 0-.63 2.317v6.743c.002.814.219 1.613.63 2.317.41.704.999 1.289 1.708 1.695l5.887 3.373a4.718 4.718 0 0 0 4.676 0l5.887-3.373a4.656 4.656 0 0 0 1.709-1.695c.41-.704.627-1.503.628-2.317v-6.743a4.624 4.624 0 0 0-.629-2.317c-.41-.704-1-1.29-1.708-1.696Zm-.254 8.26-3.218 5.534a3.545 3.545 0 0 1-1.605 1.445c-.674.304-1.199.369-1.893.469-1.046.151-1.95.212-2.57.056a3.581 3.581 0 0 1-1.643-.924l-4.559-4.518a3.492 3.492 0 0 1-1.018-2.1c-.002-.62.161-1.229.474-1.764l3.222-5.534a3.52 3.52 0 0 1 1.334-1.307c.555-.308 1.443-.43 2.51-.555.709-.084 1.376-.198 2.012-.092a3.794 3.794 0 0 1 1.926.981l4.556 4.515c.44.436.758.979.921 1.575a3.483 3.483 0 0 1-.449 2.22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.06 11.125-5.31 3.928 3.432 1.872-1.43 3.95 5.31-3.928-3.432-1.872 1.43-3.95Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPaddingMissingImageIcon);
export default __webpack_public_path__ + "static/media/noPaddingMissingImageIcon.589a046d9d9491f7d75e1a4dcdb9801f.svg";
export { ForwardRef as ReactComponent };